var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9992 14.5312L30 22.0729C30 24.1614 28.3999 25.8692 26.3807 25.9928L26.1459 26H5.85514C3.8054 26 2.12938 24.3696 2.00804 22.3121L2.00101 22.0729L2 14.5312H29.9992ZM24.764 19.5369H21.2603L21.1176 19.5467C20.6046 19.6176 20.2091 20.0657 20.2091 20.608C20.2091 21.1502 20.6046 21.5983 21.1176 21.6692L21.2603 21.679H24.764L24.9066 21.6692C25.4197 21.5983 25.8151 21.1502 25.8151 20.608C25.8151 20.0657 25.4197 19.6176 24.9066 19.5467L24.764 19.5369ZM26.1459 6C28.1956 6 29.8716 7.63041 29.993 9.68791L30 9.92715L29.9992 12.3891H2L2.00101 9.92715C2.00101 7.83857 3.60111 6.1308 5.62036 6.00717L5.85514 6H26.1459Z",
    fill: "#B9FF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.8c9ba43054ab94cca072706a2e4e2d66.svg";
export { ForwardRef as ReactComponent };